exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".amazon-pay .edit[data-v-8faf0b3e],\n.amazon-pay .init[data-v-8faf0b3e] {\n  text-align: center;\n  margin-bottom: 2em;\n}\n", ""]);

// exports
